export const calculatePercent = (value: number, targets: number[]): number => {
  if (!targets || targets.length === 0) return 0;
  const sortedTargets = [...targets].sort((a, b) => a - b);
  const diffs = sortedTargets.map((t, i) => (i === 0 ? t : t - sortedTargets[i - 1]));

  const stepWidth = 100 / diffs.length;

  let realWidth = 0;
  let remain = value;

  for (const diff of diffs) {
    if (remain <= 0) break;

    const portion = Math.min(remain, diff);
    realWidth += (portion / diff) * stepWidth;
    remain -= portion;
  }

  return Math.min(realWidth, 100);
};
